import I18n from "i18n-js";
import {globalMessageHandler} from "../../../../common";
import React, {useEffect, useState} from "react";
import {ActivationType, validateToken} from "../../../activation/activationApi";
import {changeEmail} from "./changeEmailRequestApi";
import {useNavigate, useParams} from "react-router-dom";
import ActivationSuccess from "../../../../components/Activation/ActivationSuccess";
import ActivationError from "../../../../components/Activation/ActivationError";
import PageTransition from "../../../identity/PageTransition";
import {Box, CircularProgress} from "@mui/material";

interface ChangeEmailRequestDialogProps {
  paramsToken?: string;
}

export default function ChangeEmailRequestPublic({paramsToken = undefined}: ChangeEmailRequestDialogProps) {
  const [stage, setStage] = useState<string>('request');
  const params = useParams();
  const navigate = useNavigate();

  async function onActivationSuccess(token: string) {
    setStage('loading');

    const response = await changeEmail(token);
    if (response.data.success) {
      setStage('success');
    } else {
      setStage('error');
    }
  }

  async function validateParamsToken() {
    // @ts-ignore It's already validated at this point that params.token is not undefined
    const token: string = params.token;
    const response = await validateToken(token, ActivationType.EMAIL);
    const data = response.data;

    if (!data.success) {
      setStage('invalidToken');
    } else {
      onActivationSuccess(token);
    }
  }

  useEffect(() => {
    if (params.token !== undefined) {
      // Hide the default stage until token validation is done
      setStage('loading');

      validateParamsToken();
    }
  }, []);

  return (
    <>
      {
        stage === 'success'
          ? (
            <PageTransition direction={1}>
              <ActivationSuccess
                messageCategory={"Profile.changeEmailSuccess"}
                onlyContent={false}
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'error'
          ? (
            <PageTransition direction={1}>
              <ActivationError
                messageCategory={"Profile.changeEmailError"}
                onlyContent={false}
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'invalidToken'
          ? (
            <PageTransition direction={1}>
              <ActivationError
                messageCategory={"Activation.invalidTokenPage"}
                onlyContent={false}
              />
            </PageTransition>
          )
          : ''
      }
      {
        stage === 'loading'
          ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <CircularProgress/>
            </Box>
          )
          : ''
      }
    </>
  );
}